// Templates pre-prontos para criacao rapida de skills.
// Tipo Custom limpa tudo; demais prefilam intent_primary, patterns e prompt_template.

export type SkillTemplateKey = "summary" | "fact_check" | "support" | "custom";

export interface SkillTemplate {
  label: string;
  intent_primary: string;
  patterns_pt_br: string[];
  patterns_en: string[];
  prompt_template: string;
}

export const SKILL_TEMPLATES: Record<SkillTemplateKey, SkillTemplate> = {
  summary: {
    label: "Resumo de conversa",
    intent_primary: "summary_request",
    patterns_pt_br: ["resuma", "resumir", "/resumo", "resume aí", "faz um resumo"],
    patterns_en: ["summarize", "summary", "/summary"],
    prompt_template:
      "Você é a SYRA. Resume os últimos {{window_turns}} turnos do grupo {{group_name}} em até 5 bullets. Mantém tom neutro, factual, em PT-BR. Mensagem do usuário: {{message}}\n\nHistórico:\n{{history}}",
  },
  fact_check: {
    label: "Fact-check",
    intent_primary: "fact_check",
    patterns_pt_br: ["verifica", "checar", "isso é verdade", "confere", "/factcheck"],
    patterns_en: ["check", "verify", "/factcheck"],
    prompt_template:
      "Você é a SYRA. Verifique a afirmação considerando a memória do grupo e signals. Retorne (1) verdade/falso/incerto, (2) fonte ou justificativa. Afirmação: {{message}}\n\nContexto: {{history}}",
  },
  support: {
    label: "Suporte/acolhimento",
    intent_primary: "support_request",
    patterns_pt_br: ["tô mal", "estou triste", "preocupado", "preciso de ajuda", "tô ansioso"],
    patterns_en: ["i'm sad", "i need help", "i'm anxious"],
    prompt_template:
      "Você é a SYRA, especialista em acolhimento. Responde com empatia e validação emocional. NÃO dá conselho; apenas valida e oferece presença. Em PT-BR, máx. 200 chars. Mensagem: {{message}}",
  },
  custom: {
    label: "Custom",
    intent_primary: "",
    patterns_pt_br: [],
    patterns_en: [],
    prompt_template: "",
  },
};

export const SKILL_TEMPLATE_ORDER: SkillTemplateKey[] = ["summary", "fact_check", "support", "custom"];
